import script from "./ClientCabinetMobileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetMobileHeader.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetMobileHeader.vue?vue&type=style&index=0&id=4a3b939c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3b939c"]])

export default __exports__